import {Component} from '@angular/core';
import {fuseAnimations} from '../../../core/animations';

@Component({
    selector: 'dynamic-forms',
    templateUrl: './dynamic_forms.component.html',
    styleUrls: ['./dynamic_forms.component.scss'],
    animations: fuseAnimations,
    standalone: false
})

export class DynamicFormsComponent {
  dataSource;

  constructor(){}
}
